module.exports = __webpack_public_path__ + "img/giams-logo.1769c5e3.svg";